module.exports = __webpack_public_path__ + "static/actionlist-itemnumber-do-386b62e22870c603cccbcfcc3f27ad84.png";